export const streamKeys = [
    "symbol",
    "curPrice",
    "changePrice",
    "changePercentage",
];
class NewsResponseMappper {
    formatResponse(streamRes, cb) {
        var _a;
        try {
            const ResData = JSON.parse(streamRes).response.data;
            if (((_a = ResData.custom_elements) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                const data = Object.assign(Object.assign({}, ResData), { customElements: ResData.custom_elements, timeText: ResData.date });
                cb(data);
            }
            else {
                const data = Object.assign(Object.assign({}, ResData), { timeText: ResData.date });
                cb(data);
            }
        }
        catch (error) { }
    }
}
export default NewsResponseMappper;
